/**
 * Validación de contraseña para flujos de cambio/establecimiento de contraseña.
 * Requisitos: mínimo 8 caracteres, al menos un número y un carácter especial.
 */

const MIN_LENGTH = 8;
const HAS_NUMBER = /\d/;
const HAS_SPECIAL = /[^a-zA-Z0-9]/;

/**
 * Valida que la contraseña cumpla: mínimo 8 caracteres, al menos un número y un carácter especial.
 * @param {string} password - Contraseña en texto plano
 * @returns {{ valid: boolean, message?: string }}
 */
export function validatePasswordStrength(password) {
  if (!password || typeof password !== 'string') {
    return { valid: false, message: 'auth.passwordValidation' };
  }
  const trimmed = password.trim();
  if (trimmed.length < MIN_LENGTH) {
    return { valid: false, message: 'auth.passwordMinLength' };
  }
  if (!HAS_NUMBER.test(trimmed)) {
    return { valid: false, message: 'auth.passwordMustIncludeNumber' };
  }
  if (!HAS_SPECIAL.test(trimmed)) {
    return { valid: false, message: 'auth.passwordMustIncludeSpecial' };
  }
  return { valid: true };
}

/**
 * Retorna una función rule para Vuetify (v => true | errorMessage).
 * @param {Vue} vm - Instancia del componente (para vm.$t)
 * @returns {function(string): boolean|string}
 */
export function passwordStrengthRule(vm) {
  return (v) => {
    const str = v != null ? String(v).trim() : '';
    if (str.length === 0) return true; // required se valida aparte
    const result = validatePasswordStrength(str);
    if (result.valid) return true;
    return vm && typeof vm.$t === 'function' ? vm.$t(result.message) : result.message;
  };
}

/**
 * Estado de cada requisito para mostrar lista visual (✓/✗).
 * @param {string} password
 * @returns {{ minLength: boolean, hasNumber: boolean, hasSpecial: boolean, allValid: boolean }}
 */
export function getPasswordRequirementChecks(password) {
  const str = password != null ? String(password).trim() : '';
  const minLength = str.length >= MIN_LENGTH;
  const hasNumber = HAS_NUMBER.test(str);
  const hasSpecial = HAS_SPECIAL.test(str);
  return {
    minLength,
    hasNumber,
    hasSpecial,
    allValid: minLength && hasNumber && hasSpecial,
  };
}

export { MIN_LENGTH };
